const DEFAULT_LOCAL = "en";

export default DEFAULT_LOCAL;